module.exports = __webpack_public_path__ + "media/message 7.d0581215.mp3";